$.fn.isInViewport = function () {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();

  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  return elementBottom > viewportTop && elementTop < viewportBottom;
};

function getBottomOffset() {
  if (window.visualViewport) {
    return Math.max(0, window.innerHeight - (window.visualViewport.height + window.visualViewport.offsetTop));
  }
  return 0;
}

$(window).on('resize scroll', function (e) {
  // On resize, clear cached positions so they get recaptured
  if (e.type === 'resize') {
    $("section.edit-actions.text-end").each(function () {
      delete this._stickyNatural;
      $(this).removeClass('sticky');
      this.style.paddingLeft = '';
      this.style.paddingRight = '';
      this.style.bottom = '';
    });
  }

  $('footer').each(function () {
    if ($(this).isInViewport()) {
      $("section.edit-actions.text-end").each(function () {
        $(this).removeClass('sticky');
        this.style.paddingLeft = '';
        this.style.paddingRight = '';
        this.style.bottom = '';
      });
      $(".modified").css('padding-bottom', '0');
    } else {
      $("section.edit-actions.text-end").each(function () {
        // Capture natural position before making sticky
        if (!$(this).hasClass('sticky')) {
          var rect = this.getBoundingClientRect();
          this._stickyNatural = { left: rect.left, right: rect.right };
        }
        $(this).addClass('sticky');
        // Set padding to align sticky content with natural position
        if (this._stickyNatural) {
          var sidenavLeft = window.matchMedia('(max-width: 991px)').matches ? 0 : 250;
          var viewportWidth = document.documentElement.clientWidth;
          this.style.paddingLeft = Math.max(0, this._stickyNatural.left - sidenavLeft) + 'px';
          this.style.paddingRight = Math.max(0, viewportWidth - this._stickyNatural.right) + 'px';
        }
        // Compensate for mobile browser UI (address bar/toolbar)
        var bottomOffset = getBottomOffset();
        this.style.bottom = bottomOffset > 0 ? bottomOffset + 'px' : '';
      });
      $(".modified").css('padding-bottom', '78px');
    }
  });
});

// Listen for visual viewport changes (mobile browser UI showing/hiding)
if (window.visualViewport) {
  window.visualViewport.addEventListener('resize', function () {
    $("section.edit-actions.text-end.sticky").each(function () {
      var bottomOffset = getBottomOffset();
      this.style.bottom = bottomOffset > 0 ? bottomOffset + 'px' : '';
    });
  });
}
